import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import {
  HOUSEHOLD_APPLICATION_STATUS_REQUESTED,
  HOUSEHOLD_APPLICATION_STATUS_STARTED,
  HOUSEHOLD_APPLICATION_STATUS_COMPLETED,
  HOUSEHOLD_APPLICATION_STATUS_PAID,
  HOUSEHOLD_APPLICATION_STATUS_DELIVERED,
  HOUSEHOLD_APPLICATION_STATUS_ACCEPTED,
  HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED,
} from 'common/householdConstants';
import {
  isApplicationPastStatus,
  getHouseholdApplicationFlowStatus,
} from 'common/householdApplication/applicationHelpers';

import HouseholdActions from 'client/actions/Household';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

const _HOUSEHOLD_APPLICATION_STATUS_MAPPING_TO_TITLE = {
  [HOUSEHOLD_APPLICATION_STATUS_REQUESTED]: 'start',
  [HOUSEHOLD_APPLICATION_STATUS_STARTED]: 'continue',
  [HOUSEHOLD_APPLICATION_STATUS_COMPLETED]: 'pay fee',
  [HOUSEHOLD_APPLICATION_STATUS_PAID]: 'edit app',
  [HOUSEHOLD_APPLICATION_STATUS_DELIVERED]: 'done',
  [HOUSEHOLD_APPLICATION_STATUS_ACCEPTED]: 'done',
  [HOUSEHOLD_APPLICATION_STATUS_LEASE_SIGNED]: 'done',
};

class SrHouseholdApplicationStatusButton extends Component {
  static propTypes = {
    householdApplication: PropTypes.object.isRequired,
    householdApplicationSubmission: PropTypes.object,
    listing: PropTypes.object,
    isGuarantor: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
  }

  _onClick = () => {
    const {
      householdApplication,
      householdApplicationSubmission,
      listing,
      isGuarantor,
      dispatch,
      history,
    } = this.props;
    const householdApplicationStatusGroup = getHouseholdApplicationFlowStatus({
      householdApplication,
      householdApplicationSubmission,
      isGuarantor,
    });

    switch (householdApplicationStatusGroup) {
      case HOUSEHOLD_APPLICATION_STATUS_PAID: {
        history.push(
          `/rental-application/${householdApplication.userId}/${listing.id}/form`
        );
        break;
      }
      case HOUSEHOLD_APPLICATION_STATUS_REQUESTED:
      case HOUSEHOLD_APPLICATION_STATUS_STARTED: {
        if (isGuarantor) {
          dispatch(HouseholdActions.startGuarantorApplication, {
            householdId: householdApplication.householdId,
            listingId: listing.id,
          });
        }
        else {
          dispatch(HouseholdActions.startApplication, {
            listingId: listing.id,
          });
        }
        break;
      }
      case HOUSEHOLD_APPLICATION_STATUS_COMPLETED:
        if (isGuarantor) {
          history.push(`/application/payment?${queryString.stringify({
            applicationId: householdApplication.id,
            listingId: listing.id,
          })}`);
        }
        else {
          history.push(
            `/application/${householdApplication.userId}/${listing.id}/pay-form`
          );
        }
        break;
    }
  }

  render() {
    const { householdApplication, householdApplicationSubmission, isGuarantor } = this.props;
    const householdApplicationStatusGroup = getHouseholdApplicationFlowStatus({
      householdApplication,
      householdApplicationSubmission,
      isGuarantor,
    });

    return (
      <ButtonDeprecated
        onClick={this._onClick}
        className='SrHouseholdApplicationStatusButton'
        disabled={
          isApplicationPastStatus(householdApplication, HOUSEHOLD_APPLICATION_STATUS_DELIVERED)
        }
      >
        {_HOUSEHOLD_APPLICATION_STATUS_MAPPING_TO_TITLE[householdApplicationStatusGroup]}
      </ButtonDeprecated>
    );
  }
}

SrHouseholdApplicationStatusButton.displayName = 'SrHouseholdApplicationStatusButton';

export default SrHouseholdApplicationStatusButton;
